<template>
    <div class="panel panel-default">
        <div class="color-map">
            <div class="color-marker-header">
                <h2>Цветовые обозначения</h2>
            </div>

            <div class="row">
                <div class="col-lg-2">
                    <div class="color-marker-box color-marker-box-yellow"></div>
                    Производился<br>
                    окрас детали
                </div>
                <div class="col-lg-3">
                    <div class="color-marker-box color-marker-box-orange"></div>
                    Производился окрас<br>
                    детали с ремонтом
                </div>
                <div class="col-lg-2">
                    <div class="color-marker-box color-marker-box-pink"></div>
                    Производилась<br>
                    замена детали
                </div>
                <div class="col-lg-3">
                    <div class="color-marker-box color-marker-box-red"></div>
                    Производился ремонт несущих<br>
                    элементов кузова
                </div>
                <div class="col-lg-2">
                    <div class="color-marker-box color-marker-box-blue"></div>
                    Требуется замена детали
                </div>
            </div>

            <svg-map
                    v-if="colorMap"
                    :map="colorMap"
                    :src="`coloring_${door_count}doors.svg`"
                    :bg="`${door_count}doors.svg`"
            ></svg-map>
        </div>

        <div class="inspection-tab-white">
            <div id="external-elements">
                <div class="row" v-for="inspection_external in inspection_externals"
                     v-if="inspection_external.inspection_type == 'MEASURABLE'">
                    <h2 class="title">
                        {{ inspection_external.element.name }}
                        <span v-if="inspection_external.plastic_state == '1'"> (пластиковый)</span>
                    </h2>
                    <div class="col-lg-6">
                        <div class="image">
                            <div class="image-points">
                                <img :src="`${ inspection_external.element.image_path }`">
                                <div v-if="inspection_external.quality == 'CROSS'" class="quality"></div>
                                <div v-for="measurable_point in inspection_external.measurable_points"
                                     :style="`left: ${ measurable_point.x-12 }px;top: ${ measurable_point.y-12 }px`" class="point">
                                    <div class="marker"></div>
                                    <div class="marker-label">{{ measurable_point.pivot.value }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 elements-in-section">
                        <div class="title-photo">
                            <h3>Повреждения</h3>
                            <button class="btn btn-sm btn-edit" v-on:click="inspection_external.photo.display = !inspection_external.photo.display">Смотреть фото</button>
                            <div v-if="inspection_external.photo.display" class="inspection-photo">
                                <a :href="inspection_external.photo.url" target="_blank">
                                    <img :src="inspection_external.photo.url">
                                </a>
                            </div>
                        </div>
                        <table class="table table-striped">
                            <tbody>
                            <tr v-for="damage in inspection_external.damages">
                                <td>{{ damage.short_name }}</td>
                                <td>{{ damage.name }}</td>
                            </tr>
                            </tbody>
                        </table>

                        <div class="car_comment">
                            <div class="comment_body">{{ inspection_external.comment }}</div>
                        </div>

                        <h3>Немаркированные элементы</h3>
                        <inspection-external-unmarked :inspection_externals="inspection_externals"
                                                      :section_id="inspection_external.section_id"
                        ></inspection-external-unmarked>
                    </div>

                    <inspection-external-unmeasurable :inspection_externals="inspection_externals"
                                                      :section_id="inspection_external.section_id"
                    ></inspection-external-unmeasurable>

                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios'

    export default {
        name: 'InspectionExternal',
        props: {
            inspection_id: {},
            door_count: {}
        },
        data() {
            return {
                inspection_externals: null,
                max_damage_roof: 0,
                max_damage_right_threshold: 0,
                max_damage_left_threshold: 0,
                max_damage_windshield: 0,
                colors: {
                    'PZ': '#f14b4f',
                    'PO': '#f3e821',
                    'PO1': '#ff7f27',
                    'REPAIRED': '#ff7f27',
                    'REPLACED': '#f14b4f',
                    'DEFORMATION': '#870f16',
                    'CROSS': 'blue',
                },
            }
        },
        asyncComputed: {
            inspection_externals() {
                return axios
                    .get('/api/inspections/' + this.inspection_id + '/external', {
                        params: {}
                    })
                    .then(({data}) => {
                        for (var i in data) {
                            if (data[i].photo==null) {
                                data[i].photo={'display':false};
                            } else {
                                data[i].photo.display = false;
                            }
                        }
                        return data
                    })
            },
        },
        computed: {
            colorMap() {
                if (!this.inspection_externals) return null

                const map = {}
                var max_damage = ''

                this.inspection_externals.forEach((inspection) => {
                    if (inspection.element && inspection.element.type) {
                        if(inspection.quality == "CROSS") {
                            map[inspection.element.type] = this.colors['CROSS']
                        } else {
                            if (inspection.element.type == 'PANEL_ROOF') {
                                max_damage = this.maxDamage(inspection.damage_color, 'PANEL_ROOF')
                                if (max_damage != '') map[inspection.element.type] = max_damage
                            } else if (inspection.element.type == 'PANEL_RIGHT_THRESHOLD') {
                                max_damage = this.maxDamage(inspection.damage_color, 'PANEL_RIGHT_THRESHOLD')
                                if (max_damage != '') map[inspection.element.type] = max_damage
                                /*if (inspection.damage_color == 'DEFORMATION' && max_damage_right_threshold < 3) {
                                map[inspection.element.type] = colors[inspection.damage_color]
                                max_damage_right_threshold = 3;
                            }
                            if (inspection.damage_color == 'REPLACED' && max_damage_right_threshold < 2) {
                                map[inspection.element.type] = colors[inspection.damage_color]
                                max_damage_right_threshold = 2;
                            }
                            if (inspection.damage_color == 'REPAIRED' && max_damage_right_threshold < 1) {
                                map[inspection.element.type] = colors[inspection.damage_color]
                                max_damage_right_threshold = 1;
                            }*/ // Для тестов
                            } else if (inspection.element.type == 'PANEL_LEFT_THRESHOLD') {
                                max_damage = this.maxDamage(inspection.damage_color, 'PANEL_LEFT_THRESHOLD')
                                if (max_damage != '') map[inspection.element.type] = max_damage
                            } else if (inspection.element.type == 'WINDSHIELD') {
                                max_damage = this.maxDamage(inspection.damage_color, 'WINDSHIELD')
                                if (max_damage != '') map[inspection.element.type] = max_damage
                            }
                            else map[inspection.element.type] = this.colors[inspection.damage_color]
                        }
                    }
                })

                return map
            }
        },
        methods: {
            maxDamage(damage_color, type) {
                var map_element_type = ''

                if (type == 'PANEL_ROOF') var max_damage = this.max_damage_roof
                if (type == 'PANEL_RIGHT_THRESHOLD') var max_damage = this.max_damage_right_threshold
                if (type == 'PANEL_LEFT_THRESHOLD') var max_damage = this.max_damage_left_threshold
                if (type == 'WINDSHIELD') var max_damage = this.max_damage_windshield

                if (damage_color == 'DEFORMATION' && max_damage < 3) {
                    map_element_type = this.colors[damage_color]
                    max_damage = 3;
                }
                if (damage_color == 'REPLACED' && max_damage < 2) {
                    map_element_type = this.colors[damage_color]
                    max_damage = 2;
                }
                if (damage_color == 'REPAIRED' && max_damage < 1) {
                    map_element_type = this.colors[damage_color]
                    max_damage = 1;
                }

                if (type == 'PANEL_ROOF') this.max_damage_roof = max_damage
                if (type == 'PANEL_RIGHT_THRESHOLD') this.max_damage_right_threshold = max_damage
                if (type == 'PANEL_LEFT_THRESHOLD') this.max_damage_left_threshold = max_damage
                if (type == 'WINDSHIELD') this.max_damage_windshield = max_damage

                return map_element_type
            }
        }
    }
</script>


// WEBPACK FOOTER //
// InspectionExternal.vue?4a8c1029